import React from 'react';
import DashboardLayout from './dashboard/DashboardLayout';

function AccessDenied({ title = 'Access Denied' }) {
  return (
    <DashboardLayout title={title}>
      <div className="flex min-h-[55vh] items-center justify-center py-16">
        <div className="w-full max-w-md rounded-2xl bg-white px-6 py-10 text-center shadow-sm">
          <p className="text-xl font-semibold text-gray-900">Access Denied</p>
          <p className="mt-2 text-sm text-gray-600">
            You do not have permission to view this page.
          </p>
        </div>
      </div>
    </DashboardLayout>
  );
}

export default AccessDenied;
